
export default defineNuxtPlugin(async () => {
    const userStore = useUserStore()
    const { loggedIn } = useUserSession()

    if (userStore.is_initialized) return
    if (!loggedIn.value) return

    try {
        await userStore.fetchUser()
    } catch (error) {
        console.error('Could not load the signed-in user', error)
    }
})